window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Views ??= {};

Sparkle.LocationBrowser.Views.MapCanvas = class MapCanvas extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.initializeMap = this.initializeMap.bind(this);
    this.zoomExtents = this.zoomExtents.bind(this);
    this.createFootprints = this.createFootprints.bind(this);
    this.removeFootprints = this.removeFootprints.bind(this);
    this.selectClickedFootprintLocation = this.selectClickedFootprintLocation.bind(this);
    this.highlightFootprintLocation = this.highlightFootprintLocation.bind(this);
    this.unhighlightFootprintLocation = this.unhighlightFootprintLocation.bind(this);
    this.updateSmallMarkerClickability = this.updateSmallMarkerClickability.bind(this);
    this.areSmallMarkersActive = this.areSmallMarkersActive.bind(this);
  }

  initialize(options = {}) {
    // Backbone's constructor calls `initialize` before the decaffeinated
    // constructor reaches its `this.initializeMap = this.initializeMap.bind(this)`
    // statement, so `this.initializeMap` here is still the unbound prototype
    // method. Bind it now so jQuery's event dispatch doesn't invoke it with
    // `this === document`.
    Sparkle.GoogleMaps.load(this.initializeMap.bind(this));
    return (this.nav = jQuery(options.nav));
  }

  initializeMap() {
    const mapOptions = {
      zoom: Sparkle.Config.googleMaps.mapCenter.zoom,
      maxZoom: 18,
      center: new google.maps.LatLng(Sparkle.Config.googleMaps.mapCenter.lat, Sparkle.Config.googleMaps.mapCenter.lng),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      draggable: true,
      scrollwheel: false,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
    };

    const footprintOptions = {
      strokeWeight: 0,
      fillColor: "#ce8e00",
    };

    this.mapObject = new google.maps.Map(this.el, mapOptions);
    this.listenTo(this.collection, "reset changeScope", this.resetMarkers);
    this.listenTo(this.collection, "selectLocation", this.focusLocation);
    this.markers = [];
    this.resetMarkers();
    google.maps.event.addListenerOnce(this.mapObject, "projection_changed", this.zoomExtents);
    google.maps.event.addListener(this.mapObject, "zoom_changed", this.updateSmallMarkerClickability);
    this.mapObject.data.setStyle(footprintOptions);
    this.mapObject.data.addListener("click", this.selectClickedFootprintLocation);
    this.mapObject.data.addListener("mouseover", this.highlightFootprintLocation);
    return this.mapObject.data.addListener("mouseout", this.unhighlightFootprintLocation);
  }

  resetMarkers(center = null) {
    this.deleteMarkers();
    this.bounds = new google.maps.LatLngBounds();
    this.createMarkers(this.collection.currentScope(), this.collection.currentParent, !!this.collection.flattened());
    this.el.dataset.markerCount = this.markers.length;

    if (this.collection.currentParent) {
      this.createFootprints([this.collection.currentParent]);
    } else {
      this.createFootprints(this.collection.currentScope());
    }

    return this.zoomExtents();
  }

  deleteMarkers() {
    return (() => {
      let marker;
      const result = [];
      while ((marker = this.markers.pop())) {
        marker.setMap(null);
        result.push(marker.tooltip != null ? marker.tooltip.setMap(null) : undefined);
      }
      return result;
    })();
  }

  zoomExtents() {
    if (this.bounds.getCenter().lat() !== 0 || this.bounds.getCenter().lng() !== -180) {
      const navRect = this.nav[0].getBoundingClientRect();
      const paddingLeft = navRect.right + 100; // 100px padding so the markers don't touch the nav edge
      const paddingRight = navRect.left; // The left indent of the nav is the same amount of gutter we can expect on the right of the map, and don't want to put markers there.
      return this.mapObject.fitBounds(this.bounds, { left: paddingLeft, right: paddingRight, top: 40, bottom: 40 });
    }
  }

  createMarkers(locations, parent, flattened) {
    const iconGenerator = new IconGenerator(locations, parent, flattened);
    const clickable = this.areSmallMarkersActive();
    for (var location of Array.from(iconGenerator.getLocations())) {
      for (var address of Array.from(location.addressesWithinDistance())) {
        if (!address["lat"] || !address["lng"]) {
          return false;
        }

        var marker = this.createMarker(
          new google.maps.LatLng(address["lat"], address["lng"]),
          location.icon,
          clickable,
          location,
        );
        this.addMarkerClickHandler(location, marker, parent);
        if (!parent && !flattened) {
          this.createTooltip(location, marker);
        } else {
          marker.setTitle(location.attributes.name);
        }
      }
    }
  }

  createMarker(latLng, icon, active = true, location) {
    const marker = new google.maps.Marker({
      position: latLng,
      clickable: active,
      map: this.mapObject,
      icon,
      title: location.attributes.name,
    });
    this.markers.push(marker);
    this.bounds.extend(latLng);
    return marker;
  }

  addMarkerClickHandler(location, marker, parent) {
    return google.maps.event.addListener(marker, "click", () => this.focusLocation(location));
  }

  createFootprints(locations) {
    this.removeFootprints();
    return locations.forEach((location) => {
      const features = this.mapObject.data.addGeoJson(location.attributes.footprint);
      return features.forEach((feature) => feature.setProperty("locationId", location.attributes.id));
    });
  }

  removeFootprints() {
    return this.mapObject.data.forEach((feature) => this.mapObject.data.remove(feature));
  }

  selectClickedFootprintLocation(event) {
    return this.focusLocation(event.feature.getProperty("locationId"));
  }

  highlightFootprintLocation(event) {
    this.mapObject.data.revertStyle();
    if (!this.collection.currentParent) {
      return this.mapObject.data.overrideStyle(event.feature, { fillColor: "#9B5B00" });
    }
  }

  unhighlightFootprintLocation(event) {
    return this.mapObject.data.revertStyle();
  }

  createTooltip(location, marker) {
    const tooltip = new GoogleMapsTooltip({
      marker,
      content: location.attributes.name,
      cssClass: "gm-tooltip",
      condition: this.areSmallMarkersActive,
    });

    return (marker.tooltip = tooltip);
  }

  updateSmallMarkerClickability() {
    const clickable = this.areSmallMarkersActive();
    return this.markers.forEach((marker) => marker.setClickable(clickable));
  }

  areSmallMarkersActive() {
    return this.mapObject.getZoom() >= this.MARKER_ACTIVATION_ZOOM;
  }

  focusLocation(location) {
    location = typeof location === "number" ? { id: location } : { id: location.id };
    return Sparkle.LocationBrowser.instance.changeParentParams(location);
  }

  render() {
    return this;
  }

  resize() {
    return google.maps.event.trigger(this.mapObject, "resize");
  }

  redraw() {
    this.resize();
    return this.deleteMarkers();
  }
};

Sparkle.LocationBrowser.Views.MapCanvas.prototype.MARKER_ACTIVATION_ZOOM = 6;
Sparkle.LocationBrowser.Views.MapCanvas.prototype.el = "#lb-map";

class IconGenerator {
  constructor(locations, parent, flattened) {
    this.getLocations = this.getLocations.bind(this);
    this.createLocations = this.createLocations.bind(this);
    this.locations = locations;
    this.parent = parent;
    this.flattened = flattened;
  }

  getLocations() {
    let newLocations = [];
    let index = 0;
    this.locations.forEach((location) => {
      newLocations = newLocations.concat(this.createLocations(location, index));
      //note: each branch gets its own index, so stacked locations
      // will generate multiple pins with the same index
      return (index += 1);
    });

    //at a leaf node, there are no locations, use parent for the marker
    if (this.locations.length === 0 && this.parent) {
      newLocations = newLocations.concat(this.createLocations(this.parent, index));
    }

    return newLocations;
  }

  createLocations(location, index) {
    if (location.hasChildren()) {
      return _.reduce(
        this.locations.scoped(location.children()),
        (locations, child) => locations.concat(this.createLocations(child, index)),
        [],
      );
    } else {
      location = Object.create(location);
      location.index = index;
      location.icon = this.getIconTemplate(location, index);
      return [location];
    }
  }

  getIconTemplate(location, index) {
    let icon;
    if (this.locations.length > 26) {
      icon = this.smallIcon();
      //leaf node, display a regular pin
    } else if (this.locations.length === 0 && !location.hasChildren()) {
      icon = this.regularIcon();
      //not the root, display lettered pins
    } else if (this.parent) {
      icon = this.indexedIcon(index);
      //if it's the root, but the results are flattened, lettered pins
    } else if (!this.parent && this.flattened) {
      icon = this.indexedIcon(index);
      //small icons, should only show up for the root
    } else {
      icon = this.smallIcon();
    }

    return icon;
  }

  regularIcon() {
    return {
      url: window.Sparkle.apiHost + window.SparkleConfig.assetPaths.mapPlacemarker,
      scaledSize: new google.maps.Size(36, 48),
      anchor: new google.maps.Point(18, 48),
    };
  }

  indexedIcon(index) {
    return {
      url: window.Sparkle.apiHost + this.pinAssetUrls[index],
      scaledSize: new google.maps.Size(36, 36),
      anchor: new google.maps.Point(18, 36),
    };
  }

  smallIcon() {
    return {
      url: window.Sparkle.apiHost + window.SparkleConfig.assetPaths.mapPinpoint,
      scaledSize: new google.maps.Size(18, 18),
      anchor: new google.maps.Point(9, 9),
    };
  }
}

IconGenerator.prototype.pinAssetUrls = window.SparkleConfig.assetPaths.mapPins;

window.IconGenerator = IconGenerator;
